import { useState, useEffect, useCallback, useRef } from 'react';
import { useOidc } from "@axa-fr/react-oidc";
import TimeoutWarningModal from '../components/TimeoutWarningModal';

const SessionTimeoutTimer = () => {
    const [events] = useState(['keypress', 'click', 'load', 'focus', 'scroll', 'mouseover', 'mousedown']);
    const { logout, isAuthenticated } = useOidc();

    let timeStamp;
    let warningInactiveInterval = useRef<ReturnType<typeof setTimeout> | null>(null);
    let startTimerInterval = useRef<ReturnType<typeof setTimeout> | null>(null);

    // start inactive check
    let timeChecker = () => {
        startTimerInterval.current = setTimeout(() => {
            warningInactive();
        }, 2000);
    };

    let ClearStartTimerInterval = () => {
        if (startTimerInterval.current) {
            clearTimeout(startTimerInterval.current)
        }
    };

    let ClearWarningInactiveInterval = () => {
        if (warningInactiveInterval.current) {
            clearTimeout(warningInactiveInterval.current)
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        sessionStorage.removeItem('showModal');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        sessionStorage.removeItem('showModal');
        setIsModalOpen(false);
    };

    const handleLogin = () => {
        sessionStorage.removeItem('showModal');
        setIsModalOpen(false);
        const win: Window = window;
        win.location = window.location.origin + "/login";
    }

    // warning timer
    let warningInactive = () => {

        ClearStartTimerInterval();

        warningInactiveInterval.current = setInterval(() => {
            const sessionOutInMinutes = import.meta.env.REACT_APP_SESSIONTIMEOUT_MINUTES as string;
            const maxTime = parseInt(sessionOutInMinutes) ?? 20;//Default 20 mins
            var timeString = sessionStorage.getItem('lastTimeStamp');
            var showModal = sessionStorage.getItem('showModal');
            if (!isAuthenticated && showModal === 'true') {
                openModal();
            }
            if (timeString === null) {
                resetTimer();
                timeString = sessionStorage.getItem('lastTimeStamp');
            }

            let minPast = 0;
            if (timeString != null) {
                let currentDate = new Date();
                timeStamp = new Date(timeString);
                let differenceValue = (currentDate.getTime() - timeStamp.getTime());
                minPast = Math.floor(differenceValue / 1000 / 60);
            }

            if (isNaN(minPast) && minPast > maxTime) {
                resetTimer();
                timeString = sessionStorage.getItem('lastTimeStamp');
            }

            //console.log("minPast=" + minPast + "  maxTime=" + maxTime);

            if (isAuthenticated && !isModalOpen && !isNaN(minPast) && minPast === maxTime) {
                sessionStorage.setItem('signedOut', 'true');
                sessionStorage.setItem('showModal', 'true');
                logout();
            }

        }, 1000);
    };

    // reset interval timer
    let resetTimer = useCallback(() => {
        //console.log("resetTimer");
        ClearStartTimerInterval();
        ClearWarningInactiveInterval();

        if (isAuthenticated) {
            let timeStamp = new Date();
            sessionStorage.setItem('lastTimeStamp', timeStamp.toString());
        } else {
            sessionStorage.removeItem('lastTimeStamp');
        }
        timeChecker();

    }, [isAuthenticated, timeChecker]);

    useEffect(() => {
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        return () => {
            ClearStartTimerInterval();
        };
    }, [resetTimer, events]);

    return (
        <div>
            {isModalOpen && (
                <div>
                    <TimeoutWarningModal
                        isOpen={isModalOpen}
                        onRequestClose={() => { closeModal() }}
                        onLogin={() => handleLogin()}
                        ariaHideApp={false}
                    />
                </div>
            )
            }
        </div>
    );
};

export default SessionTimeoutTimer;